import * as MenuItemButton from '@mui/material/MenuItem';

import patchButtonBaseComponent from 'gatsby-material-ui-components/lib/patch-base-button-components';

export const MenuItem = patchButtonBaseComponent<
    HTMLDivElement,
    MenuItemButton.MenuItemProps
>(MenuItemButton.default);